export const getListagemMapaLeitos = state => {
  return state.listagemMapaLeitos;
};

export const getListagemFiltradaStatus = state => {
  return state.listagemFiltradaStatus;
};

export const getOpcoesSelect = state => {
  return state.opcoesSelect;
};

export const getListagemFiltrada = state => {
  return state.listagemFiltrada;
};
